module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a-form-inputs p-dependency-on-income"
  }, [_c('accordion', [_c('accordion-item', {
    attrs: {
      "has-error": !_vm.deceasedIncomeValid
    }
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n                Deceased's Income\n            ")]), _vm._v(" "), _c('income', {
    attrs: {
      "name": "Deceased",
      "income": _vm.theDeceased.income,
      "person": _vm.theDeceased,
      "tooltipValue": "theDeceased"
    },
    on: {
      "action": _vm.updateTheDeceasedIncome
    }
  })], 1), _vm._v(" "), _vm._l((_vm.dependants), function(dependant, index) {
    return (_vm.determineAge(dependant) > 21) ? _c('accordion-item', {
      attrs: {
        "has-error": !_vm.dependantIncomeValid(index)
      }
    }, [_c('h2', {
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_vm._v("\n                Dependant " + _vm._s(index + 1) + " Income\n            ")]), _vm._v(" "), _c('income', {
      attrs: {
        "name": "Claimant",
        "income": dependant.income,
        "index": index,
        "person": dependant,
        "tooltipValue": "dependant"
      },
      on: {
        "action": _vm.updateTheDependantIncome
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), (!_vm.hasSplitPeriods) ? _c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n                The Multiplicand\n            ")]), _vm._v(" "), _c('multiplicand')], 1) : _vm._e(), _vm._v(" "), _c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n                The Multipliers & Dependency\n            ")]), _vm._v(" "), _c('multipliers')], 1)], 2), _vm._v(" "), _c('step-button', {
    attrs: {
      "next-valid": _vm.updateValid()
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ffa7738c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/fatal-accident-claims/dependency/steps/DependencyOnIncome.vue
// module id = 1837
// module chunks = 0